import React from 'react';
import CDNSiteSideMenu from '@/modules/cdn/common/components/site/SiteSideMenu';
import LineSideMenu from '@/modules/cdn/ops/pages/LineDetail/components/LineSideMenu';
import NodeSideMenu from '@/modules/cdn/ops/pages/NodeDetail/components/NodeSideMenu';
import CloakSiteSideMenu from '@/modules/cloak/components/SiteSideMenu';

interface DetailMenuConfig {
  pattern: RegExp;
  component: React.ComponentType<any>;
  props?: Record<string, any>;
}

export const detailMenuConfigs: DetailMenuConfig[] = [
  {
    pattern:
      /^\/cloak\/protection-rules\/sites\/(?!create\b)([^/]+)(\/[^/]+)?$/,
    component: CloakSiteSideMenu,
  },
  {
    pattern: /^\/cdn-ops\/sites\/(?!create\b)([^/]+)(\/[^/]+)?$/,
    component: CDNSiteSideMenu,
    props: { mode: 'ops' },
  },
  {
    pattern: /^\/cdn-oper\/sites\/(?!create\b)([^/]+)(\/[^/]+)?$/,
    component: CDNSiteSideMenu,
    props: { mode: 'oper' },
  },
  {
    pattern: /^\/cdn-ops\/nodes\/([^/]+)(\/[^/]+)?$/,
    component: NodeSideMenu,
  },
  {
    pattern: /^\/cdn-ops\/lines\/([^/]+)(\/[^/]+)?$/,
    component: LineSideMenu,
  },
];
